import { useEffect, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfFleetExpenditure, ModelOfFleetInventory } from 'src/database';
import api from 'src/services/api';

export const useFleetReportsController = () => {
	const { userAgencyId } = useAuth();
	const [loading, setLoading] = useState(false);
	const [fleetInventoryData, setFleetInventoryData] = useState<ModelOfFleetInventory[]>([]);
	const [fleetExpenditureData, setFleetExpenditureData] = useState<ModelOfFleetExpenditure[]>([]);

	useEffect(() => {
		getFleetInventoryData();
		getFleetExpenditureData();
	}, []);

	const getFleetExpenditureData = () => {
		setLoading(true);
		api.get(`fleetExpenditureData/${userAgencyId}/2024`)
			.then((response) => {
				setFleetExpenditureData(response.data.VEICULOS);
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
			});
	};

	const generateFleetExpenditureReport = (reportData: ModelOfFleetExpenditure[]) => {
		console.log(reportData);
		api.post('fleetExpenditureReport', { VEICULOS: reportData }, { responseType: 'arraybuffer' })
			.then((response) => {
				let blob = new Blob([response.data], {
					type: 'application/pdf',
				});

				let url = window.URL.createObjectURL(blob);
				let link = document.createElement('a');
				link.href = url;
				link.download = 'file.pdf';
				window.open(link.href);

				setTimeout(() => {
					window.URL.revokeObjectURL(url);
				}, 100);
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const getFleetInventoryData = () => {
		setLoading(true);
		api.get(`fleetInventoryData/${userAgencyId}`)
			.then((response) => {
				setFleetInventoryData(response.data.VEICULOS);
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
			});
	};

	const generateFleetInventoryReport = (reportData: ModelOfFleetInventory[]) => {
		api.post('fleetInventoryReport', { VEICULOS: reportData }, { responseType: 'arraybuffer' })
			.then((response) => {
				let blob = new Blob([response.data], {
					type: 'application/pdf',
				});

				let url = window.URL.createObjectURL(blob);
				let link = document.createElement('a');
				link.href = url;
				link.download = 'file.pdf';
				window.open(link.href);

				setTimeout(() => {
					window.URL.revokeObjectURL(url);
				}, 100);
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	return {
		getFleetReport: {
			loading,
			fleetInventoryData,
			fleetExpenditureData,
		},
		handleFleetReport: {
			generateFleetInventoryReport,
			generateFleetExpenditureReport,
		},
	};
};
